import React from 'react';
import Grid from "@material-ui/core/Grid";
import WorkingTimeInput from "./WorkingTimeInput";
import {makeStyles} from "@material-ui/core";
import {weekdays} from "../data/data";
import {uniqBy} from "lodash";

const useStyles = makeStyles((theme) => ({
	label: {
		fontSize: 12,
        paddingTop: theme.spacing(2)
	}
}));

const WorkingTimeWeekly = ({value, onChange}) => {

	const classes = useStyles();

	// Sometimes data may be corrupted
    // make values unique
    if (value) {
        value = uniqBy(value, 'Weekday');
    }

    const onValueChange = (v, weekday) => {

        if (v) {
            const hasWeekday = value.filter(x => x.Weekday == weekday).length > 0;

            let newCurrentValue = {};
            if (hasWeekday) {
                newCurrentValue = value.map(x => x.Weekday == weekday ? Object.assign({ Weekday: weekday }, v) : x);
            } else {
                newCurrentValue = value.map(x => x);
                newCurrentValue.push(Object.assign({ Weekday: weekday }, v) );
            }

            onChange(newCurrentValue);
        }
    }

    const getValueForWeekday = (weekday) => {
        if (!value) {
            return null;
        }

        const weekdayValue = value.filter(x => x.Weekday == weekday);

        if (weekdayValue.length > 0) {
           return weekdayValue[0];
        } else {
           return { From: 0, To: 24 * 60 };
        }
    }

	return (
	    <Grid container>
            {weekdays.map((item, i) => {
                return (
                    <Grid container key={i}>
                        <Grid item xs={2}  className={classes.label}>{item.label}</Grid>
                        <Grid item xs={10}>
                            <WorkingTimeInput value={getValueForWeekday(item.value)} onChange={(e) => onValueChange(e, item.value)} />
                        </Grid>
                    </Grid>
                    )
            })}
        </Grid>
	);
}

export default WorkingTimeWeekly;